import React from 'react';
import { Switch } from '@cargomatic/ui';
/**
 * Toggle switch filter matching filter bar height.
 */
export function FilterToggle({ checked, onCheckedChange, disabled = false, }) {
    return (React.createElement("div", { className: "h-8 flex items-center" },
        React.createElement(Switch, { checked: checked, onCheckedChange: onCheckedChange, disabled: disabled })));
}
